export default __webpack_public_path__ + "static/media/banner-BG.cef584ca.jpg";